import { Button as AntButton } from 'antd';
import classes from './Button.module.scss';

const Button = ({
  children,
  onClick,
  mode = 'contained',
  wide = false,
  ...props
}) => {
  return (
    <AntButton
      color='primary'
      onClick={onClick}
      {...props}
      className={`${classes.default} ${classes[mode]} ${wide && classes.wide} ${props.className} ${props.disabled && classes.disabled}`}
    >
      {children}
    </AntButton>
  );
};

export default Button;
